
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[id]/honest-guide",
      function () {
        return require("private-next-pages/collections/[id]/honest-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[id]/honest-guide"])
      });
    }
  